import {
  FeatureValue,
  IBrandFeature,
  IDefaultFeature,
  IStageFeature,
} from '../models/feature.interfaces';

export function isBrandFeature(value: any): value is IBrandFeature {
  return !!value?.brands;
}

export function isStageFeature(value: any): value is IStageFeature {
  return !value?.brands && !!value?.stages;
}

export function isDefaultFeature(value: any): value is IDefaultFeature {
  return !value.stages && !value.brands;
}

export function isFeatureEnabled(
  environments: FeatureValue[],
  brand: string,
  stage: string
): boolean {
  // Brand always wins
  const brandFeature = environments.find(
    (item) => isBrandFeature(item) && item.brands.includes(brand)
  ) as IBrandFeature;
  if (
    brandFeature != null &&
    (brandFeature?.stages == null || brandFeature.stages.includes(stage))
  ) {
    return brandFeature.value;
  }

  // Use stage where not brand is defined
  const stageFeature = environments.find(
    (item) => isStageFeature(item) && item.stages.includes(stage)
  ) as IStageFeature;

  if (stageFeature != null) {
    return stageFeature.value;
  }

  // Fallback to default feature otherwise default to true
  return environments.find((item) => isDefaultFeature(item))?.value ?? true;
}
